<template>
    <card>
    <template slot="header">
        <h4 class="card-title pb-5p">{{i18nValues['deliveryDetail']}}</h4>
    </template>
    <el-tabs v-model="tabName" tab-position="bottom" stretch class="dashBoardTabs">
        <el-tab-pane :label="i18nValues['last15Days']" name="last15Days">
        <bar-chart
            :height="300"
            :labels="bar15Days.labels"
            :datasets="bar15Days.datasets"
        ></bar-chart>
        </el-tab-pane>
        <el-tab-pane :label="i18nValues['last6Months']" name="last6Months">
        <bar-chart
            :height="300"
            :labels="bar6Months.labels"
            :datasets="bar6Months.datasets"
        ></bar-chart>
        </el-tab-pane>
    </el-tabs>
    </card>
</template>
<script>
import BarChart from "@/components/dashboard/BarChart";
export default {
  name: "DeliveryDetailSection",
  props: {
    tabName: String,
    bar15Days: Object,
    bar6Months: Object,
  },
  components: {
    BarChart,
  },
  methods: {
  },
  data() {
      return {
      }
  }
}
</script>
<style scoped>
    .align-end {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-end;
        align-items: center;
        align-content: center;
    }
    .el-tabs__item {
        padding: 0px !important;
    }
    .pb-5p {
        padding-bottom: 5px;
    }
</style>